import _ from 'lodash'

export default {

    namespaced:true,

    state: {

        logged_in_user: undefined,

    },// state

    getters: {

        getAll: (state,getters,rootState,rootGetters) => { return rootGetters.getAll('users') },
        getOne: (state,getters,rootState,rootGetters) => (key) =>  { return rootGetters.getOne('user',key) },

        my_user(state,getters,rootState,rootGetters){
            var users = getters.getAll.filter((user)=> user.uid == state.logged_in_user.uid )
            if( !users ) return
            return users[0]
        },

        my_user_key(state,getters,rootState,rootGetters){ if(!getters.my_user) return; return getters.my_user.key },

        get_initials: (state,getters,rootState,rootGetters) => ( user ) => 
        {
            return user.email.replace('@milk-studio.dk','')
        },

        my_initials(state,getters,rootState,rootGetters) {
            return getters.get_initials( getters.my_user )
        },

        
    },// getters

    mutations: {

        set_logged_in_user(state, input) {      
            state.logged_in_user = input        
        },

    },// mutations

}


// WEBPACK FOOTER //
// ./src/store/modules/users.js